import { SvgIconProps } from '@material-ui/core';
import { fileInfoType } from 'api/file/interfaces/get-file';

export enum NavLinkBadgeStatus {
  Success = 'success',
  Warning = 'warning',
  Idle = 'idle',
  Error = 'error',
}

export type NavLinkBadgeStatusType = NavLinkBadgeStatus;

export type NavLinkType = {
  linkText: string;
  path: string;
  linkClassName?: string;
  icon?: SvgIconProps;
  sublinks?: NavLinkType[];
  expanded?: boolean;
  testId?: string;
  dataTestId?: string;
  category?: string;
  isDisabled?: boolean;
  isHidden?: boolean;
  notification?: 'dot' | 'standard';
  notificationStatus?: 'default' | 'primary' | 'secondary' | 'error' | undefined;
  onClickCustom?: () => void;
  badgeContentFunction?: (
    token: string,
    props: { fileId?: string; firmId?: string; [key: string]: unknown },
    setFileData?: (data: fileInfoType) => void,
  ) => Promise<number | NavLinkBadgeStatus | undefined>;
};
